import { createApiEffect } from '@/features/api/common/create-api-effect'
import { ExportAssignmentQueryParams } from '@/features/api/assignment/types/types'

export const exportEmployeesListFx = createApiEffect<ExportAssignmentQueryParams, Blob>({
  requestMapper: (query) => ({
    method: 'GET',
    url: '/api/user-app/employee/list/export/',
    responseType: 'blob',
    query,
  }),
})
